import React from 'react'
import { FieldValues, useFormContext, UseFormReturn } from 'react-hook-form'

interface Props {
  children: Function
}

const ConnectForm = ({ children }: Props) => {
  const methods = useFormContext()
  return children({ ...methods })
}

export default ConnectForm
